import Api from "@/services/Api";
import { useMenuStore } from "@/stores/menu";
import { useUserStore } from "@/stores/user";

export function formatNotificationTime(date) {
  if (!date) return "";
  const parsed = new Date(String(date).replace(" ", "T"));
  if (Number.isNaN(parsed.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(parsed.getDate())}.${pad(parsed.getMonth() + 1)}.${parsed.getFullYear()} ${pad(parsed.getHours())}:${pad(parsed.getMinutes())}`;
}

export function notificationMeta(notification) {
  const type = notification?.type;
  if (type === "discount_request") {
    const detail = [notification.requested_by_name, notification.customer_name, notification.pos_name].filter(Boolean).join(" · ");
    return {
      title: "Kërkesë për zbritje",
      detail: detail || "Pret konfirmim",
      icon: "fa-solid fa-user",
      iconClass: "bg-orange-50 text-orange-700",
      destination: "Zbritje",
    };
  }
  if (type === "price_change") {
    const failed = notification.status === "failed";
    return {
      title: notification.title || (failed ? "Ndryshimi i çmimeve dështoi" : "Ndryshimi i çmimeve u aplikua"),
      detail: `${notification.product_count || 0} produkte · ${failed ? "Dështoi" : "Aplikuar"}`,
      icon: "fa-solid fa-tags",
      iconClass: "bg-sky-50 text-sky-700",
      destination: "Çmimet",
    };
  }
  if (type === "offer_change") {
    const failed = notification.status === "failed";
    const count = notification.product_count ? ` · ${notification.product_count} produkte` : "";
    return {
      title: notification.title || (failed ? "Oferta u aktivizua me dështime" : "Oferta u aktivizua"),
      detail: `${notification.label || "Oferta"} · ${failed ? "Aktive me dështime" : "U aktivizua"}${count}`,
      icon: "fa-solid fa-percent",
      iconClass: "bg-purple-50 text-purple-700",
      destination: "Oferta",
    };
  }
  if (type === "stock_intake") {
    return {
      title: notification.title || "Erdhi furnizimi",
      detail: `${notification.movement_count || 0} rreshta furnizimi`,
      icon: "fa-solid fa-boxes-stacked",
      iconClass: "bg-green-50 text-green-700",
      destination: "Furnizime",
    };
  }
  return {
    title: notification?.title || "Njoftim",
    detail: "",
    icon: "fa-solid fa-bell",
    iconClass: "bg-gray-100 text-gray-600",
    destination: "",
  };
}

export async function openNotification(router, notification) {
  const menu = useMenuStore();
  if (notification.type === "discount_request") {
    menu.show_menu_notifications = false;
    router.push({ name: "Konfirmo zbritje", params: { id: notification.discount_request_id } });
    return;
  }
  if (notification.type === "price_change") {
    if (notification.batch_id) {
      try {
        await Api(true).post("product/pricing-offers/price-batches/mark-notification-read", {
          batch_id: notification.batch_id,
        });
      } catch (_) {
        /* still navigate */
      }
      await useUserStore().get_user_notifications();
    }
    menu.show_menu_notifications = false;
    router.push({ name: "Cmimet" });
    return;
  }
  if (notification.type === "offer_change") {
    if (notification.guid) {
      try {
        await Api(true).post("product/pricing-offers/campaign/mark-notification-read", {
          guid: notification.guid,
        });
      } catch (_) {
        /* still navigate */
      }
      await useUserStore().get_user_notifications();
    }
    menu.show_menu_notifications = false;
    router.push({ name: "Oferta dhe Fushata" });
    return;
  }
  if (notification.type === "stock_intake") {
    if (notification.sync_id) {
      try {
        await Api(true).post("stock/financa/mark-intake-read", {
          sync_id: notification.sync_id,
        });
      } catch (_) {
        /* still navigate */
      }
      await useUserStore().get_user_notifications();
    }
    menu.show_menu_notifications = false;
    router.push({ name: "Gjendja analitike", query: { tab: "supply" } });
  }
}
